import { useEffect, useState } from "react";
import {
  getTermsAccepted,
  getTermsContent,
  setTermsAccept,
  getPrivacyAccepted,
  getPrivacyContent,
  setPrivacyAccept,
} from "../services/policiesService";
import { baseContainer } from "@base-provider";

const TermsPoliciesHandler = ({termsPolicies}) => {
  const [termsConditions, setTermsConditions] = useState(null);
  const [privacyPolicy, setPrivacyPolicy] = useState(null);
  const [showAccessDenied, setShowAccessDenied] = useState(false);

  useEffect(() => {
    // Make a request to check if user has accepted Terms and Conditions before
    fetchTermsAndConditions();
  }, []);

  const appName = baseContainer.config.appName;
  const TermsPolicies = termsPolicies;

  const fetchTermsAndConditions = () => {
    getTermsAccepted(appName).then((response) => {
      if (!response.data) {
        // If user has not accepted Terms and Conditions make a request to get the content and show the popup
        getTermsContent(appName).then((response) => {
          setTermsConditions(response.data.text);
        });
      } else {
        // else make a request to check if user has accepted Privacy Policy before
        fetchPrivacyPolicy();
      }
    });
  };

  const fetchPrivacyPolicy = () => {
    getPrivacyAccepted(appName).then((response) => {
      // If user has not accepted Privacy Policy make a request to get the content and show the popup
      if (!response.data) {
        getPrivacyContent(appName).then((response) => {
          setPrivacyPolicy(response.data.text);
        });
      }
    });
  };

  // When user accepts Terms and Conditions, make a request to save the new status and hide the popup
  const handleAcceptTermsConditions = () => {
    setTermsAccept(appName).then(() => {
      setTermsConditions(null);
      //Then make a request to check if user has accepted Privacy Policy before
      fetchPrivacyPolicy();
    });
  };

  // When user accepts Privacy Policy, make a request to save the new status and hide the popup
  const handleAcceptPrivacyPolicy = () => {
    setPrivacyAccept(appName).then(() => {
      setPrivacyPolicy(null);
    });
  };

  // If user declines Terms and Conditions or Privacy Policy show the access denied popup for 5 seconds and log the user out
  const handlePoliciesDecline = () => {
    setTermsConditions(null);
    setPrivacyPolicy(null);
    setShowAccessDenied(true);
    setTimeout(() => {
      setShowAccessDenied(false);
      baseContainer.authenticationService.logout();
    }, 5000);
  };

  return (
    (termsConditions || privacyPolicy || showAccessDenied) && (
      <TermsPolicies
        acceptTermsConditions={handleAcceptTermsConditions}
        acceptPrivacyPolicy={handleAcceptPrivacyPolicy}
        declinePolicies={handlePoliciesDecline}
        termsConditions={termsConditions}
        privacyPolicy={privacyPolicy}
        showAccessDenied={showAccessDenied}
      />
    )
  );
};

export default TermsPoliciesHandler;
